import { useMemo } from 'react';
import { useGetBFAwardsLeaderboardQuery } from 'common/store/modules/api/cfs-api';

/**
 * If there is a live season we should get and return the current round number used by selectors here
 *
 * @param seasonId string The ID of the season inside the competition, passed from the nav component
 * @returns {number} The current round number or -1 if it is not found
 */
export function useGetCurrentRoundNumber(seasonId) {
    const { data: leaderboardData } = useGetBFAwardsLeaderboardQuery(
        { seasonId },
        { skip: !seasonId }
    );

    const currentRoundNumber = useMemo(() => {
        if (
            leaderboardData?.status !==
                PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE &&
            leaderboardData?.status !==
                PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED
        ) {
            return -1;
        }

        const allRoundNumbers =
            leaderboardData.leaderboard?.flatMap(
                (item) =>
                    item.roundByRoundTotalVotes
                        ?.flat()
                        .map((i) => i.roundNumber) || []
            ) || [];

        const uniqueRoundNumbers = new Set(allRoundNumbers);

        if (uniqueRoundNumbers.size === 0) {
            return -1;
        }

        return Math.max(...uniqueRoundNumbers);
    }, [leaderboardData?.status, leaderboardData?.leaderboard]);
    return currentRoundNumber;
}
